export const shadow = {
  elev0: "none",
  elev1: "0 12px 36px -6px rgba(26,27,35,0.06)",
  elev2: "0 24px 48px rgba(26,27,35,0.12)",
};